//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ListedSingleCoin',
  props: {
    coin: {
      type: Object,
      default: null
    }
  }
}
